module.exports = {"buildVersion":"2.31.5-240103189","release":"2.31.5","buildDateTime":"Wed Jan 03 2024 06:18"}


//////////////////
// WEBPACK FOOTER
// ./src/metadata.json
// module id = 2137
// module chunks = 25